/**
 * Окно «Приложения» карточками (06.10.2026, владелец: «если приложений много, чтобы по нажатию на кнопку меню
 * приложений открывался попап и там приложения карточками, а карточки разделены на секции по принадлежности к
 * организации. Для каждой карточки сгенерируй новую картинку в стиле brix»).
 *
 * Картинка — по виду приложения: одно и то же приложение у разных организаций — одна картинка, различает секция.
 * Кадры — public/app-cards (Codex на Pageo, 06.10.2026; зелёный фон вырезан). Неизвестный вид — без картинки,
 * карточка с буквой. Мало приложений и все одной организации — прежний список (у сотрудника КБ их ровно 7).
 */
import "@/styles/apps-cards.css";

export interface AppCard { pic: string; hint: string }
type AppLike = { kind?: string | null; slug?: string | null; name?: string | null };

/** С какого числа приложений окно карточками (у сотрудника КБ их 7 — у него остаётся список). */
export const APPS_CARDS_FROM = 8;

const CARDS: Record<string, AppCard> = {
  drive:      { pic: "/app-cards/drive.webp",      hint: "Файлы компании" },
  calendar:   { pic: "/app-cards/calendar.webp",   hint: "Задачи и сроки" },
  editor:     { pic: "/app-cards/editor.webp",     hint: "Документы и таблицы" },
  control:    { pic: "/app-cards/control.webp",    hint: "Отчёты по сделкам" },
  focal:      { pic: "/app-cards/focal.webp",      hint: "Важные сделки" },
  visits:     { pic: "/app-cards/visits.webp",     hint: "Замеры и выезды" },
  production: { pic: "/app-cards/production.webp", hint: "Сроки производства" },
};
const BY_KIND: Record<string, keyof typeof CARDS> = {
  docs: "editor", reports: "control", focal: "focal", visits_schedule: "visits", visits_funnel: "production",
};

export function appCardOf(app: AppLike): AppCard | null {
  if (app.kind === "group") {   // группы-приложения: «Диск» и «Календарь» (у каждой организации свои)
    const s = app.slug ?? "";
    if (s.endsWith("drive-root") || app.name === "Диск") return CARDS.drive;
    if (s.endsWith("tasks-root") || app.name === "Календарь") return CARDS.calendar;
    return null;
  }
  const k = app.kind ? BY_KIND[app.kind] : undefined;
  return k ? CARDS[k] : null;
}
